import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Settlement/rightAngle.png'


const _withScopeId = n => (_pushScopeId("data-v-5f89868e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Settlement" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "费用说明", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "rightAngle",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "headContent" }
const _hoisted_7 = { class: "classTitle" }
const _hoisted_8 = { class: "contentBox" }
const _hoisted_9 = {
  key: 0,
  class: "paymentTime"
}
const _hoisted_10 = {
  key: 0,
  class: "remaining"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 剩余支付时间：", -1))
const _hoisted_12 = { class: "countTime" }
const _hoisted_13 = { class: "block" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1))
const _hoisted_15 = { class: "block" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1))
const _hoisted_17 = { class: "block" }
const _hoisted_18 = { class: "content" }
const _hoisted_19 = { class: "item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 姓名 ", -1))
const _hoisted_21 = { class: "labelText" }
const _hoisted_22 = { class: "item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 性别 ", -1))
const _hoisted_24 = { class: "labelText" }
const _hoisted_25 = { class: "item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 身份证号码 ", -1))
const _hoisted_27 = { class: "labelText" }
const _hoisted_28 = { class: "item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 出生日期 ", -1))
const _hoisted_30 = { class: "labelText" }
const _hoisted_31 = { class: "item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 联系方式 ", -1))
const _hoisted_33 = { class: "labelText" }
const _hoisted_34 = { class: "item" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 所在省市 ", -1))
const _hoisted_36 = { class: "labelText" }
const _hoisted_37 = { class: "item" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 毕业院校 ", -1))
const _hoisted_39 = { class: "labelText" }
const _hoisted_40 = { class: "item" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 毕业专业 ", -1))
const _hoisted_42 = { class: "labelText" }
const _hoisted_43 = { class: "item" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 毕业层次 ", -1))
const _hoisted_45 = { class: "labelText" }
const _hoisted_46 = { class: "item" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 毕业时间 ", -1))
const _hoisted_48 = { class: "labelText" }
const _hoisted_49 = { class: "item" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  style: {"width":"200px"}
}, " 是否有普高或中职档案 ", -1))
const _hoisted_51 = { class: "labelText" }
const _hoisted_52 = { class: "item" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  style: {"width":"200px"}
}, " 继续教育档案领取情况 ", -1))
const _hoisted_54 = { class: "labelText" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hasSelect" }, " 已选费用 ", -1))
const _hoisted_56 = { class: "cardContent" }
const _hoisted_57 = { class: "footBtm" }
const _hoisted_58 = { class: "foottext" }
const _hoisted_59 = { class: "yingfu" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" 应付金额 ")
const _hoisted_61 = { class: "symbol" }
const _hoisted_62 = { class: "money" }
const _hoisted_63 = { class: "symbol" }
const _hoisted_64 = { class: "hasSelectTip" }
const _hoisted_65 = { class: "flexBox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountDown = _resolveComponent("CountDown")!
  const _component_CardItem = _resolveComponent("CardItem")!
  const _component_Pay = _resolveComponent("Pay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.fee.info['remark'])
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "plan",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPlan && _ctx.showPlan(...args)))
          }, _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.fee.info.name), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.cancel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("h5", null, "订单" + _toDisplayString(_ctx.fee.info.payStatus == 1 ? '待支付' : '已支付'), 1),
              (_ctx.fee.info.payStatus==1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_CountDown, {
                      time: _ctx.fee.info.cancelOrderCountdown*1000,
                      format: "HH:mm:ss"
                    }, {
                      default: _withCtx((timeData) => [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.getNumberTime(timeData).hours), 1),
                          _hoisted_14,
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getNumberTime(timeData).minutes), 1),
                          _hoisted_16,
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.getNumberTime(timeData).seconds), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["time"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.fee.dossierInfo.authName), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.fee.dossierInfo.sex), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.fee.dossierInfo.authNum), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.fee.dossierInfo.birthday), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.fee.dossierInfo.mobile), 1)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.fee.dossierInfo.provinceName +"/"+ _ctx.fee.dossierInfo.cityName), 1)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.fee.dossierInfo.collegeName), 1)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.fee.dossierInfo.majorName), 1)
          ]),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.fee.dossierInfo.layerName), 1)
          ]),
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.fee.dossierInfo.graduationDate), 1)
          ]),
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.fee.dossierInfo.isSeniorSchoolDossier == 0 ? "否" : "是"), 1)
          ]),
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.fee.dossierInfo.isReceiveDossier == 0 ? "未领取" : "已领取"), 1)
          ])
        ])
      ]),
      _hoisted_55,
      _createElementVNode("div", _hoisted_56, [
        _createVNode(_component_CardItem, {
          list: _ctx.fee.info.itemList
        }, null, 8, ["list"])
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", {
            class: _normalizeClass(["submitMoney", {'flexEnd':!_ctx.cancel}])
          }, [
            _createElementVNode("div", _hoisted_59, [
              _hoisted_60,
              _withDirectives(_createElementVNode("span", _hoisted_61, "¥", 512), [
                [_vShow, !_ctx.cancel]
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _withDirectives(_createElementVNode("span", _hoisted_63, "¥ ", 512), [
                [_vShow, _ctx.cancel]
              ]),
              _createTextVNode(_toDisplayString(_ctx.computePrice / 100), 1)
            ])
          ], 2),
          _withDirectives(_createElementVNode("div", _hoisted_64, " 请认真核对信息即费用 ", 512), [
            [_vShow, !_ctx.cancel]
          ])
        ]),
        _createElementVNode("div", _hoisted_65, [
          _withDirectives(_createElementVNode("div", {
            class: "submit cancelSubmit",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelPay && _ctx.cancelPay(...args)))
          }, " 取消支付 ", 512), [
            [_vShow, _ctx.cancel && _ctx.fee.info.payStatus==1]
          ]),
          _createElementVNode("div", {
            class: "submit toSubmit",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showPay && _ctx.showPay(...args)))
          }, " 去支付 ")
        ])
      ])
    ]),
    _createVNode(_component_Pay, {
      "order-number": _ctx.fee.orderInfo.orderNumber,
      params: _ctx.fee.params,
      "return-url": _ctx.fee.returnUrl,
      onPayStart: _ctx.payStart
    }, null, 8, ["order-number", "params", "return-url", "onPayStart"])
  ], 64))
}